import { render, staticRenderFns } from "./DefaultTableVersionNewPage.vue?vue&type=template&id=54ebf95c"
import script from "./DefaultTableVersionNewPage.vue?vue&type=script&lang=ts"
export * from "./DefaultTableVersionNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports